import { Injectable } from '@angular/core';

import { delay, Observable, of } from 'rxjs';

import { Currency, Rate } from '@iw/core/entities';

import { currenciesMock, getRatesMock } from '.';
import { DictionariesApiService } from '../api';

@Injectable()
export class DictionariesMockApi extends DictionariesApiService {
  override getCurrencies(): Observable<Currency[]> {
    return of(currenciesMock).pipe(delay(500));
  }

  override getRates(): Observable<Rate[]> {
    const rates = getRatesMock();

    return of(rates).pipe(delay(500));
  }
}
